import { UPDATE_SOCIAL_ENABLED } from '../actions';

export function socialChatEnabled(state = false, action) {
  switch (action.type) {
    case UPDATE_SOCIAL_ENABLED: {
      return action.enabled;
    }
    default:
      return state;
  }
}
